import { cn } from "@utils";

export const Badge = ({ children, color }) => {
  const colors = {
    yellow: {
      bg: "bg-yellow-50",
      text: "text-yellow-800",
      border: "ring-yellow-600/20",
    },
    green: {
      bg: "bg-green-50",
      text: "text-green-800",
      border: "ring-green-600/20",
    },
    red: {
      bg: "bg-red-50",
      text: "text-red-800",
      border: "ring-red-600/10",
    },
    zinc: {
      bg: "bg-zinc-50",
      text: "text-zinc-800",
      border: "ring-zinc-500/10",
    },
    blue: {
      bg: "bg-blue-500/2",
      text: "text-blue-500",
      border: "ring-blue-500",
    },
    brand: {
      bg: "bg-primary-50",
      text: "text-primary-600",
      border: "ring-primary-600/20",
    },
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-normal ring-1 ring-inset max-h-6",
        colors[color].bg,
        colors[color].text,
        colors[color].border
      )}
    >
      {children}
    </span>
  );
};
